module.exports = __webpack_public_path__ + "xi_image.e4cad98d.png";